import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-skeleton-loader',
  templateUrl: './skeleton-loader.component.html',
  styleUrl: './skeleton-loader.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SkeletonLoaderComponent {
  @Input() set setDataSkeleton(dataSkeleton: SkeletonSettingData) {
    this.dataSkeleton = dataSkeleton || SKELETONS_SETTING.default;
  }
  public dataSkeleton: SkeletonSettingData = SKELETONS_SETTING.default;
}

export const SKELETONS_SETTING = {
  default: {
    rows: Array.from({ length: 4 }, () => 4),
    columns: Array.from({ length: 3 }, () => 3),
    width: [
      [80, 65, 55],
      [65, 75, 45],
      [90, 65, 40],
      [65, 50, 45],
    ],
  },
};

export interface SkeletonSettingData {
  rows: Array<number>;
  columns: Array<number>;
  width: Array<Array<number>>;
}
